import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { Loader } from '..';
import { updateUi, checkHealth } from '../../redux';

import './HealthCheckResume.css';

const HealthCheckResume = () => {
    const dispatch = useDispatch();
    const { t }    = useTranslation();

    const showHealthChecksPanel = () => {
        dispatch(updateUi({ showHealthChecks: true }));
    };

    const check = () => {
        dispatch(checkHealth());
    };

    const { log, isLoading } = useSelector(state => state.health);

    const nbFailed = useMemo(() => {
        return Object.keys(log?.results || {}).reduce((nb, group) => {
            return (nb += log.results[group].filter(t => !t.result).length);
        }, 0);
    }, [log]);

    if (!nbFailed)
        return null;

    return (
        <div className="HealthCheckResume noPrint">
            <div className="alert alert-danger">
                <div className="title">
                    {t('health.system_detected_error', { count: nbFailed })}
                    <small>
                        { t('health.run_at', { date: log?.created_at?.format('LLL') }) }
                    </small>
                </div>
                <div className="content">
                    <Button size="xs" color="info" onClick={showHealthChecksPanel}>
                        <i className="fa fa-eye" />&nbsp;
                            {t('health.see_error', { count: nbFailed })}
                    </Button>
                    <Button className="ml-2" size="xs" color="primary" onClick={check}>
                        <i className="fa fa-bolt" />&nbsp;
                            {t('health.check_again')}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default HealthCheckResume;
